import React, { Component } from 'react'
import { NominacionDeCuposMultiplesDialogView } from '../../components/asignacionCupos/NominaciónDeCuposMultiplesDialogView'
import * as actions from '../../actions'
import { EMPTY_CUPO } from '../../actions/constants'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import { FORM_CUPO_MULTIPLE } from '../../../../config/forms'
import DialogView from '../../../Dialogos/DialogView'

class NominacionDeCuposMultiplesDialog extends Component {
  render () {
    const { confirmCallback, cancelCallback } = this.props
    return (
      <DialogView
        confirmCallback={confirmCallback}
        cancelCallback={cancelCallback}
        title='Nominación Múltiple de Cupos'
        content={<NominacionDeCuposMultiplesDialogView
          cargador={this.props.cargador}
          corredor={this.props.corredor}
          cereal={this.props.cereal}
          buscarCorreoCargador={this.props.buscarCorreoCargador}
          buscarCorreoCorredor={this.props.buscarCorreoCorredor}
          resetCorreoCargador={this.props.resetCorreoCargador}
          resetCorreoCorredor={this.props.resetCorreoCorredor}
          updateTablaDeCuposDisponibles={this.props.updateTablaDeCuposDisponibles}
          updateTablaCacheDeCuposNominados={this.props.updateTablaCacheDeCuposNominados}
          datosDeCupo={this.props.datosDeCupo}
          cuposDisponibles={this.props.cuposDisponibles}
          cuposCacheNominados={this.props.cuposCacheNominados}
          actualizarCuposDisponibles={this.props.actualizarCuposDisponibles}
          cantidadActual={this.props.cantidadActual}
          submitCache={this.props.submitNominacionDeCuposCache}
          cuposVigentesFiltrados={this.props.cuposVigentesFiltrados}
          updateListaCuposSeleccionados={this.props.updateListaCuposSeleccionados}
          showNotificacion={this.props.showNotificacion}
          showCloseNotificacion={this.props.showCloseNotificacion}
          clearNominacionCache={this.props.clearNominacionCache}
          userName={this.props.userName}
          roles={this.props.roles}
          isRequestingCupos={this.props.isRequestingCupos}
        />}
      />
    )
  }
}

const selector = formValueSelector(FORM_CUPO_MULTIPLE)

const mapStateToProps = state => {
  return {
    cupoNominacion: state.cupos.cupoNominacion,
    cargador: selector(state, 'remitenteComercial'),
    corredor: selector(state, 'corredorComprador'),
    datosDeCupo: state.cupos.datosDeCupo,
    cuposDisponibles: state.cupos.cuposDisponibles,
    cuposVigentesFiltrados: state.cupos.cuposVigentesFiltrados,
    cuposCacheNominados: state.cupos.cuposCacheNominados,
    cantidadActual: state.cupos.cantidadActual,
    showNotificacion: state.cupos.showNotificacion,
    userName: state.auth.username,
    roles: state.auth.roles,
    isRequestingCupos: state.cupos.isRequestingCupos
  }
}

export default connect(mapStateToProps, actions)(reduxForm({
  form: FORM_CUPO_MULTIPLE,
  initialValues: EMPTY_CUPO,
  enableReinitialize: true
})(NominacionDeCuposMultiplesDialog))
